import React, { useState } from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import { Input } from '@appkit4/react-components/field';
import { Upload } from '@appkit4/react-components/upload';
import './CreateDocTypeModal.scss';

interface CreateDocTypeModalProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: (templateName: string, file: any) => void;
    documentTypes: any[];
}

export const CreateDocTypeModal: React.FC<CreateDocTypeModalProps> = ({
    visible,
    onClose,
    onConfirm,
}) => {
    const [templateName, setTemplateName] = useState('');
    const [uploadedFile, setUploadedFile] = useState<any>(null);
    const [uploadKey, setUploadKey] = useState(0);

    const resetForm = () => {
        setTemplateName('');
        setUploadedFile(null);
        setUploadKey((prev) => prev + 1);
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleFileUpload = (file: File, fileList: FileList): void => {
        if (!file || fileList.length === 0) {
            setUploadedFile(null);
        } else {
            setUploadedFile(file);
        }
    };

    const handleFileRemove = (): void => {
        setUploadedFile(null);
    };

    const handleConfirm = () => {
        onConfirm(templateName, uploadedFile);
        resetForm();
    };

    return (
        <Modal
            visible={visible}
            onCancel={handleClose}
            title="Create export template"
            modalStyle={{ width: '33.75rem' }}
        >
            <div className="create-template-modal-content">
                <div className="form-group">
                    <label htmlFor="templateName">Document type name</label>
                    <Input
                        id="templateName"
                        type="text"
                        placeholder="Enter document type name"
                        value={templateName}
                        onChange={(value: string) => setTemplateName(value)}
                    />
                </div>

                <div className="form-group">
                    <Upload
                        key={uploadKey}
                        onChange={handleFileUpload}
                        onRemove={handleFileRemove}
                        multiple={false}
                        autoUpload={false}
                        acceptFileType=".pdf"
                        uploadInstruction="You can upload a PDF file. The max file size is 10mb."
                        uploadTitle="Upload your PDF template"
                        maxFileSize={10 * 1024 * 1024}
                        config={{
                            trigger: false,
                            type: 'inline',
                            size: true,
                        }}
                    />
                </div>

                <div className="modal-actions">
                    <Button kind="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        kind="primary"
                        onClick={handleConfirm}
                        disabled={!templateName || !uploadedFile}
                    >
                        Create
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CreateDocTypeModal;
